module.exports = __webpack_public_path__ + "static/media/1009794.311d8ac2.jpg";